/* Enhance the existing Recharge/Regios controls; never submit a second purchase form. */
window.yamInitProductPurchase = window.yamInitProductPurchase || function (root) {
  if (!root || root.dataset.yamInitialized) return;
  root.dataset.yamInitialized = 'true';
  const inQuickAdd = !!root.closest('quick-add-modal');
  const lifecycle = new AbortController();
  const observers = [];
  const observe = (callback, target, options) => {
    if (!target) return;
    const observer = new MutationObserver(callback);
    observer.observe(target, options);
    observers.push(observer);
  };
  root.yamDisposePurchase = () => {
    lifecycle.abort();
    observers.forEach(observer => observer.disconnect());
  };
  const info = root.querySelector('.product__info-container');
  const widget = root.querySelector('recharge-subscription-widget');
  const cureChoices = root.querySelector('.lds-quantity-bundle-container');
  const formatMode = root.dataset.selectionMode === 'Format';
  const cureHelp = document.createElement('p');
  cureHelp.className = 'yam-subscription-cure-help';
  cureHelp.id = `yam-subscription-cure-help-${root.id}`;
  cureHelp.hidden = true;
  cureHelp.textContent = root.dataset.subscriptionCureHelp || '';
  if (!formatMode && cureChoices && cureHelp.textContent) {
    cureChoices.before(cureHelp);
    const descriptions = (cureChoices.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
    cureChoices.setAttribute('aria-describedby', [...new Set([...descriptions, cureHelp.id])].join(' '));
  }
  const boundForms = new WeakSet();
  // Some app versions leave an unassociated hidden input outside the purchase form.
  // Bind the real Shopify plan to this form as well as retaining Recharge's UI.
  function selectedPlan(scope) {
    if (!scope) return '';
    const select = scope.querySelector('select[name="rc_plan"]');
    if (select) return select.value;
    for (const element of scope.querySelectorAll('*')) {
      if (element.shadowRoot) {
        const value = selectedPlan(element.shadowRoot);
        if (value) return value;
      }
    }
    return '';
  }
  // The existing theme builds the rotating panel asynchronously and appends it last.
  const positionReassurance = () => {
    const panel = root.querySelector('.yam-reassurance-panel');
    const target = info.querySelector('.yam-ddm');
    if (panel && target && target.nextElementSibling !== panel) target.after(panel);
  };
  observe(positionReassurance, root, { childList: true, subtree: true });
  positionReassurance();
  const cleanPrice = (node) => node ? [...node.childNodes].filter(n => n.nodeType === 3 || (n.nodeType === 1 && !n.classList.contains('visually-hidden'))).map(n => n.textContent).join('').trim() : '';
  const numberFromMoney = text => Number(text.replace(/\s/g, '').replace(/[^\d,.-]/g, '').replace(',', '.'));
  const subscriptionQuantity = cureChoices ? 1 : 0;
  const nativeDisabled = new WeakMap();
  let subscription = false;
  let pending = false;
  let shadow;
  const write = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };

  function sync() {
    pending = false;
    if (lifecycle.signal.aborted) return;
    if (shadow) {
      write(shadow.querySelector('fieldset legend'), (root.dataset.purchaseOptionsLabel || '').replace(/&#39;/g, String.fromCharCode(39)));
      [['subscription', root.dataset.subscriptionOptionLabel], ['onetime', root.dataset.onetimeOptionLabel]].forEach(([type, label]) => {
        const selector = shadow.querySelector(`[part~="rc-purchase-option__selector_${type}"]`);
        const title = selector && [...selector.childNodes].find(node => node.nodeType === 3 && node.textContent.trim());
        if (title && label && title.textContent.trim() !== label) title.textContent = label;
        const purchaseOption = selector?.closest('[part~="rc-purchase-option"]');
        if (!purchaseOption) return;
        const details = type === 'subscription' ? root.dataset.subscriptionDescription : root.dataset.onetimeDescription;
        let description = purchaseOption.querySelector('[part="yam-purchase-description"]');
        if (!description) {
          description = document.createElement('span');
          description.setAttribute('part', 'yam-purchase-description');
          description.id = `yam-purchase-description-${root.id}-${type}`;
          purchaseOption.querySelector('label').after(description);
        }
        write(description, details || '');
        const radio = selector.querySelector('input');
        if (radio) {
          const describedBy = [...new Set([...(radio.getAttribute('aria-describedby') || '').split(' ').filter(Boolean), description.id])].join(' ');
          if (radio.getAttribute('aria-describedby') !== describedBy) radio.setAttribute('aria-describedby', describedBy);
        }
        const more = selector.querySelector('rc-learn-more');
        if (more) more.style.display = 'none';
      });
    }
    const option = shadow?.querySelector('[part~="rc-purchase-option__subscription"]');
    if (inQuickAdd && root.dataset.yamPlanId && option) {
      const appBlock = widget.closest('.shopify-block.recharge-subscription-widget');
      if (appBlock?.style.display === 'none') appBlock.style.removeProperty('display');
    }
    const previousSubscription = subscription;
    subscription = !!root.dataset.yamPlanId && (root.dataset.requiresSellingPlan === 'true' || !!option?.hasAttribute('rc-selected'));
    if (root.dataset.requiresSellingPlan === 'true' && shadow) {
      const onetime = shadow.querySelector('[part~="rc-purchase-option__onetime"]');
      if (onetime) onetime.hidden = true;
      const legend = shadow.querySelector('fieldset legend');
      if (legend) legend.hidden = true;
    }
    const form = root.querySelector('.product__buy_button form');
    if (form) {
      let inputs = [...form.querySelectorAll('input[name="selling_plan"]')];
      if (!inputs.length && root.dataset.yamPlanId) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        form.append(input);
        inputs = [input];
      }
      const plan = subscription ? selectedPlan(shadow) || root.dataset.yamPlanId : '';
      inputs.forEach(input => {
        if (input.value !== plan) input.value = plan;
        if (input.disabled === subscription) input.disabled = !subscription;
      });
      if (!boundForms.has(form)) {
        boundForms.add(form);
        form.addEventListener('formdata', event => {
          if (subscription) event.formData.set('selling_plan', selectedPlan(shadow) || root.dataset.yamPlanId);
          else event.formData.delete('selling_plan');
        });
      }
    }
    root.toggleAttribute('data-subscription-active', subscription);
    cureHelp.hidden = !subscription || formatMode;
    const terms = root.querySelector('[data-yam-subscription-terms]');
    if (terms) terms.hidden = !subscription;
    const radios = [...root.querySelectorAll('.lds-quantity-input')];
    if (subscription && subscriptionQuantity > 0) {
      const single = radios.find(r => Number(r.dataset.quantity) === subscriptionQuantity);
      if (single && !single.checked) {
        single.checked = true;
        single.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    radios.forEach(radio => {
      if (!nativeDisabled.has(radio)) nativeDisabled.set(radio, radio.disabled);
      radio.disabled = nativeDisabled.get(radio) || (subscription && subscriptionQuantity > 0 && Number(radio.dataset.quantity) > 0 && Number(radio.dataset.quantity) !== subscriptionQuantity);
    });
    const submit = root.querySelector('.product-form__submit');
    if (submit && !submit.disabled) write(submit.querySelector('.button-text'), subscription ? root.dataset.subscribeLabel : root.dataset.cartLabel);
    const recurringPrice = cleanPrice(option?.querySelector('[part~="rc-purchase-option__discounted-price"]')) || cleanPrice(option?.querySelector('[part~="rc-purchase-option__price"]'));
    if (subscription && recurringPrice) write(submit?.querySelector('.button-price'), `${recurringPrice}${root.dataset.subscriptionPriceSuffix || ''}`);
    if (previousSubscription && !subscription) {
      const popular = radios.find(radio => Number(radio.dataset.quantity) === 2 && !radio.disabled);
      if (popular && !popular.checked) {
        popular.checked = true;
        popular.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const selected = radios.find(radio => radio.checked);
      const label = selected && root.querySelector(`label[for="${CSS.escape(selected.id)}"]`);
      const price = label?.querySelector('.variant-option-button-label__price')?.textContent.trim();
      if (price) write(submit?.querySelector('.button-price'), price);
      info._ldsVariantHandler?.();
    }
    radios.forEach(radio => {
      const label = root.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
      if (!label) return;
      const priceNode = label.querySelector('.variant-option-button-label__price');
      let subscriptionPrice = label.querySelector('.yam-subscription-card-price');
      if ((Number(radio.dataset.quantity) <= 0 || Number(radio.dataset.quantity) === subscriptionQuantity) && !subscriptionPrice && priceNode) {
        subscriptionPrice = document.createElement('span');
        subscriptionPrice.className = 'yam-subscription-card-price';
        priceNode.after(subscriptionPrice);
      }
      if (subscriptionPrice && recurringPrice) write(subscriptionPrice, recurringPrice);
      const displayedPrice = subscription && radio.checked ? recurringPrice : priceNode?.textContent;
      const amount = numberFromMoney(displayedPrice || '');
      const originalPrice = subscription && radio.checked
        ? cleanPrice(option?.querySelector('[part~="rc-purchase-option__original-price"]')) || cleanPrice(priceNode)
        : label.querySelector('.lds-price-discount-autodisplay s')?.textContent.trim() || '';
      let compare = label.querySelector('.yam-card-original-price');
      if (!compare && priceNode) {
        compare = document.createElement('s');
        compare.className = 'yam-card-original-price';
        priceNode.before(compare);
      }
      if (compare) {
        write(compare, originalPrice);
        compare.hidden = !(amount > 0 && numberFromMoney(originalPrice) > amount);
        compare.setAttribute('aria-label', `${root.dataset.regularPriceLabel} ${originalPrice}`);
      }
      let discount = label.querySelector('.yam-card-discount');
      if (!discount && priceNode) {
        discount = document.createElement('span');
        discount.className = 'yam-card-discount';
        priceNode.parentElement.append(discount);
      }
      const saving = numberFromMoney(originalPrice) > amount && amount > 0
        ? Math.round((1 - amount / numberFromMoney(originalPrice)) * 100) : 0;
      if (discount) {
        write(discount, saving > 0 ? `−${saving}%` : '');
        discount.hidden = saving <= 0;
      }
      const unit = label.querySelector('.variant-option-button-label__unit-price');
      const days = formatMode ? 0 : Number(radio.dataset.quantity) * Number(root.dataset.daysPerPot || 0);
      if (unit && amount > 0 && days > 0) {
        const old = unit.textContent;
        const formatted = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: root.dataset.currency || 'EUR' }).format(amount / days);
        write(unit, old.replace(/^[^/]+/, `${formatted} `));
      }
    });
    const starting = root.querySelector('.yam-starting-price[data-base-price]');
    if (starting) {
      const base = Number(starting.dataset.basePrice) / 100;
      let minimum = Number(starting.dataset.nativeStartingPrice) / 100;
      radios.forEach(radio => {
        if (nativeDisabled.get(radio)) return;
        const label = radio.parentElement.querySelector('.variant-option-button-label');
        const total = numberFromMoney(label?.querySelector('.variant-option-button-label__price')?.textContent || '');
        const quantity = Math.max(1, Number(radio.dataset.quantity) || 1);
        if (total > 0) minimum = Math.min(minimum, total / quantity);
      });
      const reduced = minimum > 0 && minimum < base;
      if (minimum > 0) write(starting.querySelector('[data-yam-starting-amount]'), new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: root.dataset.currency || 'EUR' }).format(minimum));
      const original = starting.querySelector('[data-yam-starting-original]');
      const saving = starting.querySelector('[data-yam-starting-saving]');
      if (original) original.hidden = !reduced;
      if (saving) {
        saving.hidden = !reduced;
        write(saving, (saving.dataset.label || '').replace('__PERCENT__', String(Math.round((base - minimum) / base * 100))));
      }
    }

    const selectedPrice = root.querySelector('.yam-selected-price');

    if (selectedPrice) {
      const price = selectedPrice.querySelector('.price');
      const badge = selectedPrice.querySelector('.yam-selected-price__saving');
      const subscriptionView = selectedPrice.querySelector(
        '.yam-selected-price__subscription'
      );

      const subscriptionAmount = numberFromMoney(recurringPrice || '');
      const showSubscription = subscription &&
        subscriptionAmount > 0 && !!subscriptionView;

      let original;
      let current;
      let onSale;

      if (showSubscription) {
        const normalText =
          cleanPrice(option?.querySelector(
            '[part~="rc-purchase-option__original-price"]'
          )) ||
          price?.querySelector(
            '.price__regular > .price-item--regular'
          )?.textContent.trim() || '';

        original = numberFromMoney(normalText);
        current = subscriptionAmount;
        onSale = original > current;

        write(
          subscriptionView.querySelector('[data-yam-subscription-original]'),
          normalText
        );
        write(
          subscriptionView.querySelector('[data-yam-subscription-current]'),
          recurringPrice
        );

        subscriptionView.querySelector(
          '[data-yam-subscription-original]'
        ).hidden = !onSale;
      } else {
        original = numberFromMoney(
          price?.querySelector('.price__sale s')?.textContent || ''
        );
        current = numberFromMoney(
          price?.querySelector('.price__sale .price-item--sale')
            ?.textContent || ''
        );
        onSale = price?.classList.contains('price--on-sale');
      }

      selectedPrice.classList.toggle(
        'yam-selected-price--subscription',
        showSubscription
      );

      if (subscriptionView) {
        subscriptionView.hidden = !showSubscription;
      }

      const percent = original > 0
        ? Math.round((original - current) / original * 100)
        : 0;

      const visible = onSale &&
        current >= 0 && percent > 0 && percent <= 100;

      if (badge) {
        write(badge, visible ? `Économisez ${percent} %` : '');
        badge.hidden = !visible;
      }
    }



      if (submit?.hasAttribute('aria-label') && !submit.disabled) {
        const label = submit.innerText.replace(/\s+/g, ' ').trim();
        if (submit.getAttribute('aria-label') !== label) {
          submit.setAttribute('aria-label', label);
        }
      }
  }
  function queueSync() {
    if (!pending) { pending = true; queueMicrotask(sync); }
  }
  root.addEventListener('yam:purchase-update', queueSync, { signal: lifecycle.signal });
  root.addEventListener('change', queueSync, { signal: lifecycle.signal });

  observe(queueSync, root.querySelector('[id^="price-"]'), {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class']
  });

  const prices = root.querySelector('.lds-quantity-bundle-container');
  observe(queueSync, prices, { childList: true, subtree: true, characterData: true });
  const button = root.querySelector('.product-form__submit');
  observe(queueSync, button, { childList: true, subtree: true, characterData: true });
  // Recharge and Dawn can replace the form after the initial render.
  observe(queueSync, root.querySelector('.product__buy_button'), { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
  // Stop polling once the asynchronous app has rendered; never poll the page indefinitely.
  let tries = 0;
  function connectRecharge() {
    if (lifecycle.signal.aborted || !root.isConnected) return;
    shadow = widget?.shadowRoot;
    const option = shadow?.querySelector('[part~="rc-purchase-option__subscription"]');
    if (!option) {
      if (widget && ++tries < 100) window.setTimeout(connectRecharge, 100);
      return;
    }
    observe(queueSync, shadow, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['rc-selected'] });
    // Landing links can select a one-time cure once, after Recharge has rendered.
    const params = new URLSearchParams(window.location.search);
    const linkedOnetime = !inQuickAdd && params.get('purchase') === 'onetime' &&
      root.dataset.requiresSellingPlan !== 'true';
    const initialOption = linkedOnetime
      ? shadow.querySelector('[part~="rc-purchase-option__onetime"]')
      : option;
    if (!initialOption?.hasAttribute('rc-selected')) {
      initialOption?.querySelector('input')?.click();
    }
    sync();
    if (linkedOnetime) {
      const quantity = params.get('quantity');
      const linkedCure = [...root.querySelectorAll('.lds-quantity-input')]
        .find(radio => radio.dataset.quantity === quantity && !radio.disabled);
      if (linkedCure) {
        linkedCure.checked = true;
        linkedCure.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
  sync();
  connectRecharge();

  if (!inQuickAdd) {
  const mobilePurchase = document.createElement('div');
  mobilePurchase.className = 'yam-mobile-purchase';
  mobilePurchase.hidden = true;
  const mobileButton = document.createElement('button');
  mobileButton.type = 'button';
  mobilePurchase.append(mobileButton);
  document.body.append(mobilePurchase);
  const mobileViewport = window.matchMedia('(max-width: 749px)');
  function syncMobilePurchase() {
    const nativeButton = root.querySelector('.product__buy_button .product-form__submit');
    if (!nativeButton) { mobilePurchase.hidden = true; return; }
    const bounds = nativeButton.getBoundingClientRect();
    const originalVisible = bounds.top < window.innerHeight && bounds.bottom > 0;
    // Keep the launcher clear of both the native and the fixed purchase button.
    const chatBottom = originalVisible && bounds.bottom > window.innerHeight - 144
      ? Math.max(84, window.innerHeight - bounds.top + 16) : 84;
    const chatOffset = `${Math.ceil(chatBottom)}px`;
    if (document.body.style.getPropertyValue('--yam-chat-bottom') !== chatOffset) {
      document.body.style.setProperty('--yam-chat-bottom', chatOffset);
    }
    mobilePurchase.hidden = !mobileViewport.matches || originalVisible || info.getBoundingClientRect().top > window.innerHeight;
    write(mobileButton, nativeButton.innerText.replace(/\s+/g, ' ').trim());
    mobileButton.disabled = nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true';
    mobileButton.setAttribute('aria-busy', nativeButton.classList.contains('loading') ? 'true' : 'false');
  }
  mobileButton.addEventListener('click', () => {
    const nativeButton = root.querySelector('.product__buy_button .product-form__submit');
    if (nativeButton && !nativeButton.disabled && nativeButton.getAttribute('aria-disabled') !== 'true') nativeButton.click();
  });
  let mobileFrame = 0;
  const queueMobilePurchase = () => {
    if (mobileFrame) return;
    mobileFrame = requestAnimationFrame(() => { mobileFrame = 0; syncMobilePurchase(); });
  };
  window.addEventListener('scroll', queueMobilePurchase, { passive: true });
  window.addEventListener('resize', queueMobilePurchase, { passive: true });
  mobileViewport.addEventListener('change', queueMobilePurchase);
  new MutationObserver(queueMobilePurchase).observe(root.querySelector('.product__buy_button'), { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
  syncMobilePurchase();
  }

  const ddm = root.querySelector('.yam-ddm');
  const ddmButton = ddm?.querySelector('button');
  ddmButton?.addEventListener('click', () => {
    const open = ddm.classList.toggle('is-open');
    ddmButton.setAttribute('aria-expanded', String(open));
    if (!open) ddmButton.blur();
  });
  (inQuickAdd ? root : document).addEventListener('keydown', event => {
    if (event.key === 'Escape' && ddm) {
      ddm.classList.remove('is-open');
      ddmButton.setAttribute('aria-expanded', 'false');
      ddmButton.blur();
    }
  });
  (inQuickAdd ? root : document).addEventListener('click', event => {
    if (ddm && !ddm.contains(event.target)) {
      ddm.classList.remove('is-open');
      ddmButton.setAttribute('aria-expanded', 'false');
    }
  });

  const header = document.querySelector('.section-header');
  if (header && !inQuickAdd) {
    const measure = () => document.documentElement.style.setProperty('--yam-header-offset', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    new ResizeObserver(measure).observe(header);
    measure();
  }
};
document.querySelectorAll('[data-yam-pdp-pilot]').forEach(window.yamInitProductPurchase);



